import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../Styles/GalleryPage.css'; 
import Galleryimg2 from '../images/galleryimages/galleryimg2.jpg';
import Galleryimg3 from '../images/galleryimages/galleryimg3.jpg';
import Galleryimg4 from '../images/galleryimages/galleryimg4.jpg';

const useIntersectionObserver = (options) => {
  const [entry, setEntry] = React.useState(null);
  const [node, setNode] = React.useState(null);

  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      setEntry(entry);
    }
  }, options);

  React.useEffect(() => {
    const { current: currentObserver } = { current: observer };
    currentObserver.disconnect();

    if (node) currentObserver.observe(node);

    return () => currentObserver.disconnect();
  }, [node, observer]);

  return [setNode, entry];
};

const GalleryPage = () => {
  // Helper for scroll animations
  const AnimateOnScroll = ({ children, animationClass, style }) => {        
    const [ref, entry] = useIntersectionObserver({ threshold: 0.1 });
    return (
      <div 
        ref={ref} 
        className={`animate-on-scroll ${entry?.isIntersecting ? animationClass : ''}`} 
        style={style}
      >
        {children}
      </div>
    );
  };

  return (
    <div className="gallery-page">
      {/* ✅ SEO Helmet */}
      <Helmet>
        <title>Gallery | Groomwell Women Salon Hafeezpet</title>
        <meta
          name="description"
          content="Browse Groomwell Salon’s gallery of stunning hair transformations, bridal makeovers, facials, and spa treatments. See why clients trust us with 4.9★ ratings."
        />
        <meta
          name="keywords"
          content="salon gallery Hafeezpet, hair makeovers, bridal makeup gallery, facial results, Groomwell Salon"
        />
        <meta property="og:title" content="Groomwell Salon Gallery - Hair & Beauty Transformations" />
        <meta property="og:description" content="See the best hairstyles, facials & bridal makeup looks done at Groomwell Salon Hafeezpet." />
        <meta property="og:image" content="https://www.blinkfamilysalon.in/GROOMWELLINTERIOR.jpg" /> 
        <meta property="og:url" content="https://www.blinkfamilysalon.in/gallery" />
        <link rel="me" href="https://www.instagram.com/groomwellsalon/" />
      </Helmet>

      <AnimateOnScroll animationClass="slide-in-left">
        <h2 className="gallery-title">Gallery</h2>
      </AnimateOnScroll>

      <div className="gallery-grid">
        {/* Card 1 */}
        <AnimateOnScroll animationClass="float-up">
          <div className="gallery-card">
            <img src="/GROOMWELLINTERIOR.jpg" alt="Groomwell Salon Interior in Hafeezpet" />
          </div>
        </AnimateOnScroll>

        {/* Card 2 */}
        <AnimateOnScroll animationClass="float-up" style={{ animationDelay: '100ms' }}>
          <div className="gallery-card">
            <img src={Galleryimg4} alt="Bridal Makeup at Groomwell Salon Hafeezpet" />
          </div>
        </AnimateOnScroll>

        {/* Card 3 */}
        <AnimateOnScroll animationClass="float-up" style={{ animationDelay: '200ms' }}>
          <div className="gallery-card">
            <img src={Galleryimg2} alt="Hair Styling at Groomwell Salon Hafeezpet" />
          </div>
        </AnimateOnScroll>

        {/* Card 4 */}
        <AnimateOnScroll animationClass="float-up" style={{ animationDelay: '300ms' }}>
          <div className="gallery-card">
            <img src={Galleryimg3} alt="Facial & Skincare Treatment at Groomwell Salon" />
          </div>
        </AnimateOnScroll>
      </div>
    </div>
  );
};

export default GalleryPage;
